"use client";

import { useState } from "react";
import { Heading, Icon, Image } from "@pamperedchef/design-system";

import { VideoModal } from "../VideoModal";
import * as styles from "./VideoGallery.module.scss";

export interface VideoGalleryItem {
	title: string;
	videoUrl: string;
	poster?: { src: string; alt: string };
}

export interface VideoGalleryProps {
	heading?: string;
	videos: VideoGalleryItem[];
}

export function VideoGallery({
	heading,
	videos
}: VideoGalleryProps): JSX.Element | null {
	const [playing, setPlaying] = useState<VideoGalleryItem | null>(null);

	if (videos.length === 0) return null;

	return (
		<section className={styles["gallery"]} data-component="VideoGallery">
			{heading ? (
				<Heading tag="h2" className={styles["gallery__heading"]}>
					{heading}
				</Heading>
			) : null}
			<ul className={styles["gallery__grid"]}>
				{videos.map((video, index) => (
					<li key={`${video.videoUrl}-${index}`}>
						<button
							type="button"
							className={styles["gallery__tile"]}
							aria-label={`Play ${video.title}`}
							onClick={() => setPlaying(video)}
						>
							{video.poster ? (
								<Image
									src={video.poster.src}
									alt=""
									className={styles["gallery__poster"]}
								/>
							) : null}
							<span
								className={styles["gallery__play"]}
								aria-hidden="true"
							>
								<Icon name="play" size="24px" />
							</span>
						</button>
					</li>
				))}
			</ul>
			<VideoModal
				open={playing !== null}
				onClose={() => setPlaying(null)}
				title={playing?.title}
				videoUrl={playing?.videoUrl}
				poster={playing?.poster?.src}
			/>
		</section>
	);
}
